var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.bootstrapClass[_vm.lowerCaseTenantDomainTheme]) + " " + (_vm.bootstrapClass[_vm.lowerCaseTenantDomainTheme]) + "-" + _vm.boxColor)},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b78af97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCard.vue
// module id = 2291
// module chunks = 1